import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { changeFeatureHover } from 'shared/map-search/actions/features';
import { TFeature } from 'shared/map-search/types/map';
import { TThunkDispatch } from 'shared/map-search/types/redux';

import { useBalloonHandlers } from './useBalloonHandlers';
import { useBalloonPromoHandlers } from './useBalloonPromoHandlers';
import { usePointHandlers } from './usePointHandlers';

export const useRedesignHoverEffects = (isRedesign: boolean, isResultsAvailable: boolean) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const hoveredFeatureRef = React.useRef<TFeature | null>(null);

  const onFeatureMouseEnter = useEventCallback((feature: TFeature) => {
    dispatch(changeFeatureHover(feature, true));

    hoveredFeatureRef.current = feature;
  });

  const onFeatureMouseLeave = useEventCallback(() => {
    const hoveredFeature = hoveredFeatureRef.current;

    if (!hoveredFeature) {
      return;
    }

    dispatch(changeFeatureHover(hoveredFeature, false));

    hoveredFeatureRef.current = null;
  });

  /**
   * Отдельно обрабатывается ховер на:
   * - пины
   * - балуны
   * - промо балуны (с пульсацией)
   *
   * Балуны лежат в разных objectManager'ах, пины - в hotspotsLayer, поэтому обработка у них разная
   */

  usePointHandlers({
    onFeatureMouseEnter,
    onFeatureMouseLeave,
    hoveredFeatureRef,
    isResultsAvailable,
    isRedesign,
  });

  useBalloonHandlers({
    onFeatureMouseEnter,
    onFeatureMouseLeave,
    hoveredFeatureRef,
    isRedesign,
  });

  useBalloonPromoHandlers({
    onFeatureMouseEnter,
    onFeatureMouseLeave,
    hoveredFeatureRef,
    isRedesign,
  });
};
